(() => {
  const SIZE_SELECT_SELECTOR = '[data-fake-select]';
  const COLOR_SELECT_SELECTOR = '[data-color-fake-select]';
  const VARIANT_SELECT_SELECTOR = 'variant-selects select[name^="options["]';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }

    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function getRoundedDiscountPercent(price, compareAtPrice) {
    if (!compareAtPrice || compareAtPrice <= price) return null;

    const discount = compareAtPrice - price;
    const discountPercent = (discount * 100) / compareAtPrice;

    return Math.round(discountPercent / 10) * 10;
  }

  function updatePriceNodes({ variant, priceEl, comparePriceEl, discountEl }) {
    if (!variant) return;

    const price = Number(variant.price);
    const compareAtPrice = Number(variant.compare_at_price || 0);
    const hasDiscount = compareAtPrice > price;

    if (priceEl) {
      priceEl.innerHTML = formatMoney(price);
    }

    if (comparePriceEl) {
      if (hasDiscount) {
        comparePriceEl.innerHTML = formatMoney(compareAtPrice);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.innerHTML = '';
        comparePriceEl.hidden = true;
      }
    }

    if (discountEl) {
      if (hasDiscount) {
        const discountPercent = getRoundedDiscountPercent(price, compareAtPrice);
        discountEl.innerHTML = `-${discountPercent}%`;
        discountEl.hidden = false;
      } else {
        discountEl.innerHTML = '';
        discountEl.hidden = true;
      }
    }
  }

  function getProductJson() {
    const productJson = document.querySelector('[type="application/json"][data-product-json]');
    if (!productJson) return null;

    try {
      return JSON.parse(productJson.textContent);
    } catch (error) {
      console.warn('JSON produit principal invalide.', error);
      return null;
    }
  }

  function getSelectedOptions() {
    return Array.from(document.querySelectorAll(VARIANT_SELECT_SELECTOR)).map((select) => select.value);
  }

  function findVariantBySelectedOptions(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) return null;

    return (
      product.variants.find((variant) => {
        return selectedOptions.every((optionValue, index) => {
          const key = `option${index + 1}`;
          return variant[key] === optionValue;
        });
      }) || null
    );
  }

  function getCurrentVariantFromInput(product) {
    if (!product || !Array.isArray(product.variants)) return null;

    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], [name="id"][form]');
    const variantId = Number(variantInput?.value);

    if (!variantId) return null;

    return product.variants.find((variant) => Number(variant.id) === variantId) || null;
  }

  function getCurrentVariant() {
    const product = getProductJson();
    if (!product) return null;

    const selectedOptions = getSelectedOptions();

    return (
      findVariantBySelectedOptions(product, selectedOptions) ||
      getCurrentVariantFromInput(product)
    );
  }

  function updateMainFakeSelectPrice(variant = null) {
    const currentVariant = variant || getCurrentVariant();

    if (!currentVariant) return;

    const fakeSelect = document.querySelector(SIZE_SELECT_SELECTOR);
    if (!fakeSelect) return;

    updatePriceNodes({
      variant: currentVariant,
      priceEl: fakeSelect.querySelector('[data-fake-select-price]'),
      comparePriceEl: fakeSelect.querySelector('[data-fake-select-compare-price]'),
      discountEl: fakeSelect.querySelector('[data-fake-select-discount]')
    });

    const currentProductOption = fakeSelect.querySelector('[data-current-product-option]');

    if (currentProductOption) {
      if (currentVariant.url) {
        currentProductOption.href = currentVariant.url;
      }

      updatePriceNodes({
        variant: currentVariant,
        priceEl: currentProductOption.querySelector('[data-current-product-price]'),
        comparePriceEl: currentProductOption.querySelector('[data-current-product-compare-price]'),
        discountEl: currentProductOption.querySelector('[data-current-product-discount]')
      });
    }
  }

  function getVariantFromEvent(event) {
    return event.detail?.variant || event.detail?.resource || null;
  }

  function closeSizeSelect(select) {
    if (!select) return;

    const trigger = select.querySelector('[data-fake-select-trigger]');
    const dropdown = select.querySelector('[data-fake-select-dropdown]');

    select.classList.remove('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (dropdown) {
      dropdown.hidden = true;
    }
  }

  function openSizeSelect(select) {
    if (!select) return;

    const trigger = select.querySelector('[data-fake-select-trigger]');
    const dropdown = select.querySelector('[data-fake-select-dropdown]');

    select.classList.add('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    if (dropdown) {
      dropdown.hidden = false;
    }
  }

  function closeAllSizeSelects(except = null) {
    document.querySelectorAll(SIZE_SELECT_SELECTOR).forEach((select) => {
      if (except && select === except) return;
      closeSizeSelect(select);
    });
  }

  function closeColorSelect(select) {
    if (!select) return;

    const trigger = select.querySelector('[data-color-trigger]');
    const dropdown = select.querySelector('[data-color-dropdown]');

    select.classList.remove('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (dropdown) {
      dropdown.hidden = true;
    }
  }

  function openColorSelect(select) {
    if (!select) return;

    const trigger = select.querySelector('[data-color-trigger]');
    const dropdown = select.querySelector('[data-color-dropdown]');

    select.classList.add('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    if (dropdown) {
      dropdown.hidden = false;
    }
  }

  function closeAllColorSelects(except = null) {
    document.querySelectorAll(COLOR_SELECT_SELECTOR).forEach((select) => {
      if (except && select === except) return;
      closeColorSelect(select);
    });
  }

  function syncColorSelect(fakeSelect) {
    if (!fakeSelect) return;

    const wrapper = fakeSelect.closest('.product-form__input');
    if (!wrapper) return;

    const nativeSelect = wrapper.querySelector('[data-native-color-select]');
    const currentLabel = fakeSelect.querySelector('[data-color-current-label]');
    const currentImage = fakeSelect.querySelector('[data-color-current-image]');
    const options = fakeSelect.querySelectorAll('[data-color-option]');

    if (!nativeSelect) return;

    const activeOption = Array.from(options).find((option) => option.dataset.value === nativeSelect.value);
    if (!activeOption) return;

    const optionImage = activeOption.querySelector('.fake-select__color-image');

    if (currentLabel) {
      currentLabel.textContent = nativeSelect.value;
    }

    if (currentImage && optionImage) {
      currentImage.innerHTML = optionImage.innerHTML;
    }

    options.forEach((option) => {
      const isActive = option.dataset.value === nativeSelect.value;
      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function syncAllColorSelects() {
    document.querySelectorAll(COLOR_SELECT_SELECTOR).forEach(syncColorSelect);
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncAllColorSelects();
    updateMainFakeSelectPrice();
  });

  document.addEventListener('click', (event) => {
    const sizeTrigger = event.target.closest('[data-fake-select-trigger]');
    const colorTrigger = event.target.closest('[data-color-trigger]');
    const colorOption = event.target.closest('[data-color-option]');

    if (sizeTrigger) {
      event.preventDefault();

      const sizeSelect = sizeTrigger.closest(SIZE_SELECT_SELECTOR);
      const isOpen = sizeSelect.classList.contains('is-open');

      closeAllSizeSelects(sizeSelect);
      closeAllColorSelects();

      if (isOpen) {
        closeSizeSelect(sizeSelect);
      } else {
        openSizeSelect(sizeSelect);
      }

      return;
    }

    if (colorTrigger) {
      event.preventDefault();
      event.stopPropagation();

      const colorSelect = colorTrigger.closest(COLOR_SELECT_SELECTOR);
      const isOpen = colorSelect.classList.contains('is-open');

      closeAllColorSelects(colorSelect);
      closeAllSizeSelects();

      if (isOpen) {
        closeColorSelect(colorSelect);
      } else {
        openColorSelect(colorSelect);
      }

      return;
    }

    if (colorOption) {
      event.preventDefault();
      event.stopPropagation();

      const colorSelect = colorOption.closest(COLOR_SELECT_SELECTOR);
      const wrapper = colorOption.closest('.product-form__input');
      const nativeSelect = wrapper?.querySelector('[data-native-color-select]');
      const value = colorOption.dataset.value;

      if (!colorSelect || !nativeSelect || !value) return;

      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      closeColorSelect(colorSelect);
      syncColorSelect(colorSelect);

      requestAnimationFrame(() => {
        updateMainFakeSelectPrice();
        syncAllColorSelects();
      });

      return;
    }

    if (!event.target.closest(SIZE_SELECT_SELECTOR)) {
      closeAllSizeSelects();
    }

    if (!event.target.closest(COLOR_SELECT_SELECTOR)) {
      closeAllColorSelects();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeAllSizeSelects();
    closeAllColorSelects();
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-native-color-select]')) {
      const fakeSelect = event.target
        .closest('.product-form__input')
        ?.querySelector('[data-color-fake-select]');

      syncColorSelect(fakeSelect);

      requestAnimationFrame(() => {
        updateMainFakeSelectPrice();
        syncAllColorSelects();
      });

      return;
    }

    if (event.target.matches(VARIANT_SELECT_SELECTOR)) {
      requestAnimationFrame(() => {
        updateMainFakeSelectPrice();
        syncAllColorSelects();
      });
    }
  });

  document.addEventListener('variant:change', (event) => {
    const variant = getVariantFromEvent(event);
    updateMainFakeSelectPrice(variant);

    requestAnimationFrame(() => {
      syncAllColorSelects();
    });
  });

  document.addEventListener('variant-change', (event) => {
    const variant = getVariantFromEvent(event);
    updateMainFakeSelectPrice(variant);

    requestAnimationFrame(() => {
      syncAllColorSelects();
    });
  });
})();